import { render, staticRenderFns } from "./BottomLineProvenance.vue?vue&type=template&id=f2f6f592&scoped=true&"
import script from "./BottomLineProvenance.vue?vue&type=script&lang=js&"
export * from "./BottomLineProvenance.vue?vue&type=script&lang=js&"
import style0 from "./BottomLineProvenance.vue?vue&type=style&index=0&id=f2f6f592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f6f592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2f6f592')) {
      api.createRecord('f2f6f592', component.options)
    } else {
      api.reload('f2f6f592', component.options)
    }
    module.hot.accept("./BottomLineProvenance.vue?vue&type=template&id=f2f6f592&scoped=true&", function () {
      api.rerender('f2f6f592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/bottomLineProvenance/BottomLineProvenance.vue"
export default component.exports